module.exports = __webpack_public_path__ + "img/patient.3ee02799.svg";